import { AnyAction, createReducer } from '@reduxjs/toolkit';

import { Features } from '../types/features';
import { setFeatures } from '../actions/app.actions';

export type FeaturesStoreState = {
	status: 'pending' | 'ready';
	variations: Features | undefined;
};

interface FeaturesReducer {
	[action: string]: (
		state: FeaturesStoreState,
		action: AnyAction,
	) => FeaturesStoreState;
}

export const initialState: FeaturesStoreState = {
	status: 'pending',
	variations: {},
};

const reducer: FeaturesReducer = {
	[setFeatures.toString()]: (state, action) => ({
		...state,
		variations: action.payload,
		status: 'ready',
	}),
};

export default createReducer(initialState, reducer);
